//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AdjacencyTol",1,0],[0,"AngularTol",1,0],[0,"AutoNormalGen",1,0],[0,"ChordalTol",1,0],[0,"ErrorMessageDisplay",1,0],[1,"ExportSelectionBlock",0,"SelectNXObjectList",0],[0,"HeaderInfo",1,0],[0,"NormalDirectionIndicator",1,0],[0,"NormalDisplay",1,0],[0,"OutputType",1,0],[1,"ReferenceSurfaceSelectionBlock",0,"SelectNXObjectList",0],[0,"ReverseNormalDirection",1,0],[0,"SheetBodyExportOption",1,0],[0,"TriangleDisplay",1,0]],[],[]];
SPLM.STLCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.STLCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.STLCreator.OutputTypeEnum = Object.freeze({
    "Binary" : "Binary", "Text" : "Text"});

SPLM.STLCreator.SheetBodyExportOptionEnum = Object.freeze({
    "IndividualSheets" : "IndividualSheets", "JoinSheets" : "JoinSheets"});

export default SPLM;